import { trans } from '@pepita-i18n/babelfish';
import gtxConstants from '@getrix/common/js/gtx-constants';
import { immobiliareBaseUrl } from './immobiliareBaseUrl';
import { SecurityFooter } from './SecurityFooter';

export const SecuritySidebar = () => {
    return (
        <aside className="login-desc">
            <div className="login-desc__content">
                <img src="/bundles/base/img/bkg-login-pro@2x.png" />
                <h1
                    className="gx-title-1"
                    dangerouslySetInnerHTML={{
                        __html: trans('login.desc.title', {
                            LEADER_URL: immobiliareBaseUrl + '/info/leader/',
                        }),
                    }}
                ></h1>
                <p>
                    {trans('login.desc.text', {
                        APP_SUBSCRIBED_AGENCIES: gtxConstants(
                            'APP_SUBSCRIBED_AGENCIES'
                        ),
                        APP_NAME: gtxConstants('APP_NAME'),
                    })}
                </p>
                <a className="gx-button" href="/signup">
                    {trans('btn.label.sign_in')}
                </a>
            </div>
            <SecurityFooter />
        </aside>
    );
};
